import React, { Component, Fragment } from "react";
import Navbar from "../partials/Navbar";
import Sidebar from "../partials/Sidebar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faList } from "@fortawesome/free-solid-svg-icons/faList";
import ReactDatatable from "@mkikets/react-datatable";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import axios from "axios";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import PairAddModal from "../partials/PairAddModal";
import PairUpdateModal from "../partials/PairUpdateModal";
import { toast, ToastContainer } from "react-toastify";
import Moment from "moment";
import $ from "jquery";
import * as myConstList from "./baseUrl";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
const baseUrl = myConstList.baseUrl;
class Pair extends Component {
  constructor(props) {
    super(props);

    this.columns = [
      {
        key: "id",
        text: "S.No.",
        className: "id",
        align: "left",
        sortable: true,
        cell: (row, index) => index + 1,
      },
      {
        key: "firstCoin",
        text: "Currency Pair Box",
        className: "name",
        align: "left",
        sortable: true,
        cell: (record) => {
          return (
            <>
              <span>{record.firstCoin.shortName} /</span>
              <span>{record.secondCoin.shortName}</span>
            </>
          );
        },
      },

      {
        key: "createdAt",
        text: "Date & Time",
        className: "date",
        align: "left",
        sortable: true,
        cell: (record) => {
          return <Fragment>{Moment(record.createdAt).format("lll")}</Fragment>;
        },
      },
      {
        key: "action",
        text: "Action",
        className: "action",
        width: 100,
        align: "left",
        sortable: false,
        cell: (record) => {
          return (
            <Fragment>
              <button
                data-toggle="modal"
                data-target="#update-user-modal"
                className="btn btn-primary btn-sm"
                onClick={() => this.editRecord(record)}
                style={{ marginRight: "5px" }}
              >
                <i className="fa fa-edit"></i>
              </button>
              <button
                className="btn btn-danger btn-sm"
                onClick={() => this.deleteRecordMgs(record)}
              >
                <i className="fa fa-trash"></i>
              </button>
            </Fragment>
          );
        },
      },
    ];

    this.config = {
      page_size: 10,
      length_menu: [10, 20, 50],
      filename: "Pair",
      no_data_text: "No user found!",
      // button: {
      //   print: true,
      //   csv: true,
      // },
      language: {
        length_menu: "Show _MENU_ result per page",
        filter: "Search in records...",
        info: "Showing _START_ to _END_ of _TOTAL_ records",
        pagination: {
          first: "First",
          previous: "Previous",
          next: "Next",
          last: "Last",
        },
      },
      show_length_menu: true,
      show_filter: true,
      show_pagination: true,
      show_info: true,
    };

    this.state = {
      records: [],
      cryptoList: [],
    };

    this.state = {
      currentRecord: {
        id: "",
        coin_first_id: "",
        coin_second_id: "",
      },
    };

    this.getData = this.getData.bind(this);
    console.log("this.getData", this.getData);
  }

  componentDidMount() {
    if (
      this.props.auth.user.pairManagement !== undefined &&
      this.props.auth.user.pairManagement !== 1
    ) {
      this.props.history.push("/dashboard");
    }
    this.getData();
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.auth.user.pairManagement !== undefined &&
      nextProps.auth.user.pairManagement !== 1
    ) {
      this.props.history.push("/dashboard");
    }

    if (
      nextProps.pairdata !== undefined &&
      nextProps.pairdata.pair !== undefined &&
      nextProps.pairdata.pair.data !== undefined &&
      nextProps.pairdata.pair.data.success !== undefined
    ) {
      $("#add-user-modal").modal("hide");
      $("#update-user-modal").modal("hide");
        console.log("pair data", nextProps)
      toast(nextProps.pairdata.pair.data.message, {
        position: toast.POSITION.TOP_CENTER,
      });
    }
    this.getData();
  }

  getData() {
      axios(baseUrl + "/api/v1/getpair")
          .then(res => {
              console.log("res.data")
              console.log(res.data)
              this.setState({ records: res.data.result})
             
             
          })
          .catch()
      axios
      .get(baseUrl+"/api/v1/getCryptocoin")
          .then(res => {
              console.log("crypto-data");
              console.log(res.data.result);
              this.setState({ cryptoList: res.data.result})
          })
          .catch()
  }


  editRecord(record) {
    this.setState({
      currentRecord: record,
      coin_first_id: record.firstCoin,
      coin_second_id: record.secondCoin,
    });
  }
  deleteRecordMgs(record) {
    confirmAlert({
      title: "Confirm to submit",
      message: "Really want to delete this pair?",
      buttons: [
        {
          label: "Yes",
          onClick: () => this.deleteRecord(record),
        },
        {
          label: "No",
        },
      ],
    });
  }

  deleteRecord(record) {
    const token = localStorage.getItem("jwtToken");
    const configs = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    axios
      .post(baseUrl + "/api/v1/deletepair", { _id: record._id },configs)
      .then((res) => {
        if (res.data.success) {
          toast("Successfully delete", {
            position: toast.POSITION.TOP_CENTER,
          });
        }
      })
      .catch();
    this.getData();
  }

  pageChange(pageData) {
    console.log("OnPageChange", pageData);
  }

  render() {
    return (
      <div>
        <Navbar />
        <div className="d-flex" id="wrapper">
          <Sidebar />
          <PairAddModal cryptoList={this.state.cryptoList} />
          <PairUpdateModal
            record={this.state.currentRecord}
            cryptoList={this.state.cryptoList}
          />
          <div id="page-content-wrapper">
            <div className="container-fluid">
              <button className="btn btn-link mt-3" id="menu-toggle">
                <FontAwesomeIcon icon={faList} />
              </button>
              <button
                className="btn btn-primary float-right mt-3 mr-2"
                data-toggle="modal"
                data-target="#add-user-modal"
              >
                <FontAwesomeIcon icon={faPlus} /> Add{" "}
              </button>

              <h4 className="mt-2 man_hadding mb-3">Pair Management </h4>
              <ReactDatatable
                config={this.config}
                records={this.state.records}
                columns={this.columns}
                onPageChange={this.pageChange.bind(this)}
              />
            </div>
          </div>
          <ToastContainer />
        </div>
      </div>
    );
  }
}

Pair.propTypes = {
  auth: PropTypes.object.isRequired,
  pairdata: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  pairdata: state.pairdata,
  records: state.records,
});

export default connect(mapStateToProps)(Pair);
